import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import {
  Condition,
  PriceOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface PriceState {
  amount: string;
  priceOption: PriceOption | null;
}

export const PRICE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<PriceState>>,
): ConditionType<PriceState, Condition.Price> => ({
  name: "Pre-Discount Price",
  description(state) {
    if (!state.priceOption) {
      return "The pre-discount price of an individual item the customer is returning";
    }
    return `The pre-discount price of an individual item is ${state.priceOption.toLowerCase()} ${moneyFormat(
      { amount: +state.amount, currency: DEFAULT_CURRENCY },
    )}`;
  },
  Details(props: ConditionTypeDetailsProps<PriceState>) {
    return React.createElement(Details, props);
  },
  empty: { amount: (0).toFixed(2), priceOption: null },
  fromModel(model) {
    return { amount: model.amount.toFixed(2), priceOption: model.priceOption };
  },
  toModel(state) {
    return {
      type: Condition.PRICE,
      amount: +state.amount,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return +state.amount >= 0 && state.priceOption !== null;
  },
});
